(function () {
  const STYLE_ID = 'modal-initialize-style';
  const INIT_CLASS = 'is-initializing';

  function injectInitStyle(targetId) {
    // Hide everything except the target slide + hide content to prevent flicker
    const css =
      '.product-media-modal.' + INIT_CLASS + ' .product-media-modal__content{visibility:hidden;opacity:0;}' +
      '.product-media-modal__content>*{display:none !important;}' +
      '.product-media-modal__content>[data-media-id="' + targetId + '"]{display:flex !important;}';
    let tag = document.getElementById(STYLE_ID);
    if (!tag) {
      tag = document.createElement('style');
      tag.id = STYLE_ID;
      document.head.appendChild(tag);
    }
    tag.textContent = css;
  }

  function removeInitStyle() {
    const tag = document.getElementById(STYLE_ID);
    if (tag) tag.remove();
  }

  function alignToTarget(modal, targetId) {
    const content = modal && modal.querySelector('.product-media-modal__content');
    if (!content) return false;

    const slide = content.querySelector('[data-media-id="' + targetId + '"]');
    if (!slide) return false;

    // Ensure no smooth scroll anims that could overshoot
    content.style.scrollBehavior = 'auto';

    // While only the target is visible, pin to it
    content.scrollLeft = 0;

    // Reveal everything and keep scroll pinned
    requestAnimationFrame(() => {
      removeInitStyle();
      modal.classList.remove(INIT_CLASS);

      // Recalculate position once layout settles
      requestAnimationFrame(() => {
        const left =
          slide.getBoundingClientRect().left - content.getBoundingClientRect().left + content.scrollLeft;
        content.scrollLeft = Math.round(left);
      });
    });

    return true;
  }

  // Intercept clicks on the zoom buttons and prime the modal
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product__media-toggle[data-media-id]');
    if (!btn) return;

    const targetId = btn.getAttribute('data-media-id'); // e.g. "SECTIONID-MEDIAID"
    const opener = btn.closest('modal-opener');
    const modalSel = opener ? opener.getAttribute('data-modal') : null;

    // Find the modal element
    const modal =
      (modalSel && document.querySelector(modalSel)) ||
      document.querySelector('.product-media-modal');

    if (!modal) return;

    // Mark initializing + hide flickers
    modal.classList.add(INIT_CLASS);
    injectInitStyle(targetId);

    // Try alignment several times as modal hydrates on mobile Safari
    let attempts = 0;
    const tryAlign = () => {
      attempts += 1;
      if (alignToTarget(modal, targetId)) return;
      if (attempts < 12) setTimeout(tryAlign, 50);
      else {
        // Fail-safe: show content anyway
        removeInitStyle();
        modal.classList.remove(INIT_CLASS);
      }
    };
    setTimeout(tryAlign, 40);
  });
})();
